<template>
  <v-container fluid>
    <v-row justify="center">
      <v-col
        cols="12"
        md="10"
        lg="6"
      >
        <v-card>
          <v-card-text>
            <div class="accessibility-statement">
              <v-row
                justify="center"
                class="mt-1 mb-2"
              >
                <v-col cols="auto">
                  <v-img
                    src="@/assets/redchirp-logo-transparent.png"
                    alt="RedChirp Logo"
                    max-width="250"
                  />
                </v-col>
              </v-row>

              <h2>Our Commitment to Accessibility</h2>
              <p>
                At RedChirp, we build tools to help small businesses compete, and that means making sure everyone can
                use them! Accessibility isn't an add-on for us; it's part of building great software. We're committed
                to
                removing barriers so that every business and every customer can interact with our platform with
                confidence.
              </p>
              <p>
                To guide our accessibility work, we've partnered with <a
                  href="https://accessibleweb.com/"
                  target="_blank"
                >Accessible Web</a>, a team of experts in digital
                accessibility. Together, we are working to remove barriers and work towards conformance with the Web
                Content Accessibility Guidelines (WCAG) 2.2 AA for various widgets we offer.
              </p>

              <h3>What We're Doing</h3>
              <ul>
                <li>Regularly scanning our website for accessibility issues that can be detected automatically and
                  working to remediate those issues when possible.</li>
                <li>Making updates and improvements based on user feedback.</li>
                <li>Making accessibility-related improvements to our widgets based on feedback from expert third-party
                  audits.</li>
              </ul>

              <h3>Contact Us</h3>
              <p>
                If you're having trouble accessing any part of our site, or if you have feedback on how we can improve
                your online experience, please contact us in one of the following ways:
              </p>
              <ul>
                <li>Fill out our <a href="#feedback-form">Report an Issue Form below</a></li>
                <li>Email us at <a href="mailto:help@redchirp.com">help@redchirp.com</a></li>
              </ul>
              <p>
                We're here to help and are committed to providing an inclusive experience for all.
              </p>
            </div>

            <v-divider class="my-6" />

            <h3
              id="feedback-form"
              class="mt-6 mb-4"
            >Report an Issue</h3>
            <p class="mb-4">
              If you encounter any accessibility barriers or have suggestions for improvement, please use the form below
              to let us know.
            </p>

            <div ref="feedback-form-container"></div>

            <p
              v-if="has_error"
              class="mt-4"
            >
              Unable to load the feedback form. Please contact us directly at
              <a href="mailto:help@redchirp.com">help@redchirp.com</a> to report accessibility
              issues.
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      has_error: false,
    };
  },

  methods: {
    load_feedback_script() {
      if (document.getElementById('aweb-feedback')) return;

      const script = document.createElement('script');
      script.id = 'aweb-feedback';
      script.type = 'text/javascript';
      script.src =
        'https://ramp.accessibleweb.com/feedback/9eCO7SVipQc94deg49Rgj07gox32TV3MJ5vjjgbfbbQ/script.js';
      script.async = true;
      script.defer = true;

      script.onerror = () => {
        this.has_error = true;
      };

      const container = this.$refs['feedback-form-container'];
      if (container) container.appendChild(script);
    },

    cleanup_feedback_script() {
      const script = document.getElementById('aweb-feedback');
      if (script) script.remove();
    },
  },

  mounted() {
    this.load_feedback_script();
  },

  beforeDestroy() {
    this.cleanup_feedback_script();
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 1.5rem;
  font-weight: 600;
  margin-top: 0.25rem;
  margin-bottom: 1rem;
}

h3 {
  font-size: 1.25rem;
  font-weight: 500;
  margin-top: 1.5rem;
  margin-bottom: 0.75rem;
}

p {
  line-height: 1.6;
  margin-bottom: 1rem;
}

ul {
  margin-bottom: 1rem;
  padding-left: 1.5rem;

  li {
    line-height: 1.6;
    margin-bottom: 0.5rem;
  }
}
</style>
